import { z } from "zod";

import { apiSlice } from "api/api.slice";
import type { UserData } from "entities/user/types";

type PutProfileArg = { body: UserData; user_id: string };

export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    putProfile: build.mutation<unknown, PutProfileArg>({
      query: ({ body, user_id }) => ({ body, method: "PUT", url: `/profile/${user_id}` }),
      responseSchema: z.unknown(),
    }),
  }),
});

export const { usePutProfileMutation } = profileApiSlice;
